import degreesConfig from "@2u-landing-pages/constants/configs/degrees.json";

const programConfigs = degreesConfig.programs.rice;

export const rice = {
  slug: "rice",
  name: "Rice University",
  colors: {
    primary1: "#d23228",
    primary2: "#fecf48",
    primary3: "#00262b",
    primary4: "#1576d4",
    text: "#000",
  },
  fonts: {
    base: "Proxima Nova, sans-serif",
    url: "https://whitelabel.2u.com/cdn/v1/5953eaf8-628e-4fb2-82fa-2db3897792ba/marketing/whitelabel.fonts.min.css?ver=1.0",
  },
  programConfigs,
};
